// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__3cNT4","withAppliedTag":"styles_withAppliedTag__2PUFP"};